import { z } from 'zod';
import { transformAndFilterValidItems } from '../../../common/tools/transformUtils';

export const ResourceTypeSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
    })
    .describe('ResourceTypeSchema');

export const ResourceTypeGroupSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
        resourceTypes: z
            .array(z.unknown())
            .transform((resourceTypes) =>
                transformAndFilterValidItems(ResourceTypeSchema, resourceTypes)
            ),
    })
    .describe('ResourceTypeGroupSchema');

export const GetResourceTypeListingSchema = z
    .object({
        getObjectFolder: z.object({
            children: z.array(z.unknown()).transform((resourceTypeGroups) =>
                transformAndFilterValidItems(ResourceTypeGroupSchema, resourceTypeGroups).map(
                    (group) => ({
                        ...group,
                        resourceTypes: transformAndFilterValidItems(
                            ResourceTypeSchema,
                            group.resourceTypes
                        ),
                    })
                )
            ),
        }),
    })
    .describe('GetResourceTypeListingSchema');
